import { ECommercialOwnershipVerificationFormViewFields } from '../enums';
import {
  TCommercialOwnershipVerificationFormViewActionsType,
  TCommercialOwnershipVerificationFormViewState,
} from '../types';

import { CADASTRAL_NUMBER_CHARS_REX_EX } from './constants';
import { EValidateActionTypes } from './enums';
import { validationRules, validationRulesEntries } from './utils';

export const getPlacementApplicationFormInitialState = (
  fields?: Partial<TCommercialOwnershipVerificationFormViewState>,
): TCommercialOwnershipVerificationFormViewState => ({
  [ECommercialOwnershipVerificationFormViewFields.Inn]: {
    errorMessage: null,
    value: '',
  },
  [ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType]: {
    errorMessage: null,
    value: undefined,
  },
  [ECommercialOwnershipVerificationFormViewFields.FirstName]: {
    errorMessage: null,
    value: '',
  },
  [ECommercialOwnershipVerificationFormViewFields.LastName]: {
    errorMessage: null,
    value: '',
  },
  [ECommercialOwnershipVerificationFormViewFields.SecondName]: {
    errorMessage: null,
    value: '',
  },
  [ECommercialOwnershipVerificationFormViewFields.CadastralNumber]: {
    errorMessage: null,
    value: '',
  },
  [ECommercialOwnershipVerificationFormViewFields.CompanyName]: {
    errorMessage: null,
    value: undefined,
  },
  ...fields,
});

export function placementApplicationFormReducer(
  state: TCommercialOwnershipVerificationFormViewState,
  action: TCommercialOwnershipVerificationFormViewActionsType,
): TCommercialOwnershipVerificationFormViewState {
  switch (action.type) {
    case ECommercialOwnershipVerificationFormViewFields.Inn:
    case ECommercialOwnershipVerificationFormViewFields.CompanyName:
      return {
        ...state,
        [action.type]: {
          value: action.payload,
          errorMessage: null,
        },
      };

    case ECommercialOwnershipVerificationFormViewFields.CadastralNumber:
      if (!CADASTRAL_NUMBER_CHARS_REX_EX.test(action.payload)) {
        return state;
      }

      return {
        ...state,
        [action.type]: {
          value: action.payload,
          errorMessage: null,
        },
      };

    case ECommercialOwnershipVerificationFormViewFields.LastName:
    case ECommercialOwnershipVerificationFormViewFields.FirstName:
    case ECommercialOwnershipVerificationFormViewFields.SecondName:
      return {
        ...state,
        [action.type]: {
          value: action.payload.trim(),
          errorMessage: null,
        },
      };

    case ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType:
      return {
        ...getPlacementApplicationFormInitialState({
          [ECommercialOwnershipVerificationFormViewFields.CadastralNumber]: {
            ...state[ECommercialOwnershipVerificationFormViewFields.CadastralNumber],
          },
          [ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType]: {
            value: action.payload,
            errorMessage: null,
          },
        }),
      };

    case EValidateActionTypes.ValidateByField:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          errorMessage: validationRules[action.payload](state[action.payload].value, state),
        },
      };

    case EValidateActionTypes.ValidateAll:
      return validationRulesEntries.reduce<TCommercialOwnershipVerificationFormViewState>(
        (accumulator, currentValue) => {
          const [ruleKey, ruleFunc] = currentValue;

          return {
            ...accumulator,
            [ruleKey]: {
              ...accumulator[ruleKey],
              errorMessage: ruleFunc(accumulator[ruleKey].value, state),
            },
          };
        },
        state,
      );

    case EValidateActionTypes.ResetState:
      return {
        ...getPlacementApplicationFormInitialState(action.payload),
      };

    // istanbul ignore next
    default:
      return state;
  }
}
